import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import store from './ngrx/store';
import { UsersEffects } from './ngrx/effects/user.effect';
import { DataFlowEffects } from './ngrx/effects/data-flow.effect';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideToastr } from 'ngx-toastr';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideStore(store.reducer),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: environment.production,
    }),
    provideEffects(UsersEffects, DataFlowEffects),
    provideAnimations(),
    provideToastr({
      maxOpened: 1,
      autoDismiss: true,
      preventDuplicates: true,
      positionClass: 'toast-top-right',
      timeOut: 3000,
    }),
  ],
};
